'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('../../components');

var _iconsComponents = require('../../icons-components');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreditCardsBanComponent = function (_React$Component) {
  (0, _inherits3.default)(CreditCardsBanComponent, _React$Component);

  function CreditCardsBanComponent(props) {
    (0, _classCallCheck3.default)(this, CreditCardsBanComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CreditCardsBanComponent.__proto__ || (0, _getPrototypeOf2.default)(CreditCardsBanComponent)).call(this, props));

    _this.handleOnLinkClick = _this.handleOnLinkClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(CreditCardsBanComponent, [{
    key: 'handleOnLinkClick',
    value: function handleOnLinkClick(event) {
      event.preventDefault();
      this.props.openStandardDeposit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$t = this.props.t,
          t = _props$t === undefined ? function () {
        var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return function (msg) {
          return '' + ctx + msg;
        };
      } : _props$t;

      var translate = t(_constants.TRANSLATION_CONTEXT);
      var text = translate('CREDIT_CARDS_BAN_MSG');
      var linkText = translate('FORM_LBL_OTHER_PAYMENT_METHODS');
      var icon = _react2.default.createElement(_iconsComponents.WarningIcon, null);

      return _react2.default.createElement(_components.CreditCardsBan, { linkText: linkText, onLinkClick: this.handleOnLinkClick, text: text, icon: icon });
    }
  }]);
  return CreditCardsBanComponent;
}(_react2.default.Component);

exports.default = CreditCardsBanComponent;